<template>
<div>
<v-form
   ref="form"
   v-model="valid"
   @submit.prevent="submit"
>
  <v-container fluid>
    <v-row justify="space-between">
      <v-col cols="4" class="text-left">

      <template v-if="!edit_mode">
            <v-btn color="" class="mr-5" @click="$router.back()">
            戻る</v-btn>
            <v-btn type="submit" color="" class="mygreen" dark>
            登録</v-btn>
      </template>

      <template v-else>
            <v-btn color="" class="mr-5"  @click="$router.back()">
            戻る</v-btn>
            <v-btn type="submit" color="" class="mr-5 mygreen" dark>
            更新</v-btn>
      </template>

      </v-col>
      <v-col cols="4" class="text-left">
      </v-col>

      <v-col cols="4" class="text-right">
        <template v-if="edit_mode">
                <v-row justify="end">
<!-- 左詰めにする -->
                    <!-- 以下2要素を一時的に非表示化（要求によりコメントアウト） -->
                    <!--
                    <v-select class="myselect mywhite text-left" v-model="dialog_selected" :items="dialogs" outlined placeholder="文書を選択してください" ></v-select>
                    <v-btn color="" dark class="ml-2 mt-1 mygreen" @click="showDialog">
                        作成
                    </v-btn>
                    -->
                </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>

  <v-card class="pa-4 pb-10 mycard">
    <v-container fluid class="myform">

        <v-row>
            <v-col cols="3" class="text-left">
                <h3 class="">{{ title }}</h3>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" xs="12" class="text-left" align-self="center">
                <div>診察券番号</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="patient.bangou" label="診察券番号" outlined  :rules="[v => !!v || '必須項目です.']" :readonly="edit_mode" :class="{'gray': edit_mode}"></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>患者名(漢字)</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field v-model="patient.sei" label="姓" outlined :rules="[v => !!v || '必須項目です.']"></v-text-field>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field v-model="patient.mei" label="名" outlined :rules="[v => !!v || '必須項目です.']"></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>患者名(カナ)</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field
                v-model="patient.sei_kana"
                label="セイ"
                :rules="[v => !!v || '必須項目です.']"
                outlined></v-text-field>
            </v-col>
            <v-col cols="2" align-self="end" class="pt-11">
                <v-text-field
                v-model="patient.mei_kana"
                label="メイ"
                :rules="[v => !!v || '必須項目です.']"
                outlined></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>性別</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="6" align-self="end" class="pt-8">
                <v-radio-group v-model="patient.sex" row mandatory :class="{'d-flex':true, 'align-center':true, 'mb-4':true}">
                    <v-radio color="rgba(0, 189, 242, 1)" label="男性" value="M"></v-radio>
                    <v-radio color="rgba(0, 189, 242, 1)" label="女性" value="F"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>生年月日</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="8" align-self="end" class="pt-11">
                <!-- 日付選択 -->
                <v-col cols="3" class="pl-0">
                    <v-menu
                        v-model="menu_birthday"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field

                            outlined

                            v-model="patient.birthday"
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="patient.birthday" @input="menu_birthday = false"
                            color="green lighten-1"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"

                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-col>
        </v-row>


        <!-- 住所 -->
        <v-row class="mt-10 mb-0">
            <v-col cols="2" class="text-left" align-self="center">
                <div>住所</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="8" align-self="center" class="text-left">
                    <span style="margin-right:10px; font-size:20px; vertical-align:middle;">〒</span>
                        <v-text-field v-model="patient.post1" outlined @blur="fetchAddress" class="mypost"></v-text-field>
                    <span style="margin-right:10px;margin-left:10px;">─</span>
                    <span>
                        <v-text-field v-model="patient.post2" outlined @blur="fetchAddress" class="mypost"></v-text-field>
                    </span>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2" class="text-left" align-self="center"> </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-4">
                <v-select v-model="pref_selected" :items="pref" outlined placeholder="未選択"></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2" class="text-left" align-self="center"> </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-2">
                <v-text-field v-model="patient.city" label="市区町村名" outlined></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2" class="text-left" align-self="center"> </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-2">
                <v-text-field v-model="patient.address" label="番地・ビル名" outlined></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>固定電話番号</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="patient.tel" label="固定電話番号" outlined @blur="validphone('tel',patient.tel)"></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>携帯電話番号</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="patient.phone" label="携帯電話番号" outlined @blur="validphone('phone', patient.phone)"></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>メールアドレス</div>
            </v-col>
            <v-col cols="1" align-self="center">
<!--                <v-chip label outlined color="red">必須</v-chip> -->
            </v-col>
            <v-col cols="4" align-self="end" class="pt-11">
                <v-text-field v-model="patient.mail" label="メールアドレス" outlined  ></v-text-field>
            </v-col>
        </v-row>


        <!-- 担当医 -->
        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>担当医</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="3" align-self="end" class="pt-11">
                        <v-select v-model="doctor_selected" :items="doctor" outlined placeholder="未選択" ></v-select>
            </v-col>
        </v-row>

        <!-- 担当スタッフ -->
        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>担当スタッフ</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="3" align-self="end" class="pt-11">
                        <v-select v-model="staff_selected" :items="staff" outlined placeholder="未選択" ></v-select>
            </v-col>
        </v-row>



        <!-- DM受取 -->
        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>DM受取</div>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="6" align-self="end" class="pt-8">
                <v-radio-group v-model="patient.dm" row mandatory class="d-flex align-center mb-4">
                    <v-radio color="rgba(0, 189, 242, 1)" label="受け取る" value="T"></v-radio>
                    <v-radio color="rgba(0, 189, 242, 1)" label="受け取らない" value="F"></v-radio>
                </v-radio-group>
            </v-col>
        </v-row>


        <!-- メモ -->
        <v-row>
            <v-col cols="2" class="text-left pt-11" align-self="start">
                <div>メモ</div>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="6" align-self="end" class="pt-11">
                            <v-textarea
                            label="メモ"
                            v-model="patient.memo"
                            outlined></v-textarea>
            </v-col>
        </v-row>

    </v-container>
  </v-card>
</v-form>


<DialogSyoukaijyou @closeDialog="closeDialog($event)" :dialogFlag="dialogFlag.syoukaijyou" :data="patient"></DialogSyoukaijyou>
<DialogShindansyo @closeDialog="closeDialog($event)" :dialogFlag="dialogFlag.shindansyo" :data="patient"></DialogShindansyo>
<DialogGohenshin @closeDialog="closeDialog($event)" :dialogFlag="dialogFlag.gohenshin" :data="patient"></DialogGohenshin>



        <template>
          <div class="text-center">
            <v-snackbar
              v-model="snackbar"
              timeout="1500"
              vertical
              top
              right
              outlined
            >
              <div v-html="snackbar_text"></div>
              <template v-slot:action="{  }">
                <img @click="snackbar = false" class="img" src="/img/x.svg" style="cursor:pointer;" />
              </template>
            </v-snackbar>
          </div>
        </template>



</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
import DialogSyoukaijyou from '@/components/DialogSyoukaijyou.vue';
import DialogShindansyo from '@/components/DialogShindansyo.vue';
import DialogGohenshin from '@/components/DialogGohenshin.vue';
/* eslint-disable */


  export default {
    components:{
        DialogSyoukaijyou, DialogShindansyo, DialogGohenshin
    },


    data() {  // datas
        return {

        snackbar: false,
        snackbar_text: '更新しました',

            title: '患者情報登録',
            valid: false,
            dialog_selected: null,

            edit_mode: false,
            dialogFlag: {
                syoukaijyou: false,
                shindansyo: false,
                gohenshin: false,
            },


            pref: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'],

            menu_birthday: '',
            dialogs: ['紹介状', '診断書', 'ご返信'],
            show_password: false,

            zipcode: '',
            doctor: [],
            staff: [],

            patient: {
                bangou: '',
                sei: '',
                mei: '',
                sei_kana: '',
                mei_kana: '',
                sex: 'M',
                birthday: '',
                post1: '',
                post2: '',
                city: '',
                address: '',
                mail: '',
                tel: '',
                phone: '',
                dm: 'T',
                memo: '',
            },
            doctor_selected: '',
            staff_selected: '',
            pref_selected: '',
        }
    },


    methods: {
        closeDialog(v){
            console.log('closeDialog()');
            console.log(v);
            this.dialogFlag[v] = false
        },

        showDialog(){
            console.log('showDialog()');
            console.log(this.dialog_selected);
            if( this.dialog_selected==='紹介状' ){
                this.dialogFlag.syoukaijyou = true
            }else if( this.dialog_selected==='診断書' ){
                this.dialogFlag.shindansyo = true
            }else if( this.dialog_selected==='ご返信' ){
                this.dialogFlag.gohenshin = true
            }
        },


      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },


        submit(){
            // 登録と更新
            console.log('%csubtmit()', mycolor.strong);
            console.log('edit_mode: ', this.edit_mode);


            // todo this.patientをpostに渡せば良いのではないか?
            let data = {
                id: null,
                memo: this.patient.memo ?? '',
                bangou: this.patient.bangou ?? '',
                address: this.patient.address ?? '',
                // 空文字はDB側のdate型でこける可能性があるのでnullに統一
                birthday: (this.patient.birthday && this.patient.birthday.trim()) ? this.patient.birthday : null,
                city: this.patient.city ?? '',
                mail: this.patient.mail ?? '',
                phone: this.patient.phone ?? '',
                post1: this.patient.post1 ?? '',
                post2: this.patient.post2 ?? '',
                sex: this.patient.sex ?? 'M',
                dm: this.patient.dm ?? 'T',
                mei: this.patient.mei ?? '',
                mei_kana: this.patient.mei_kana ?? '',
                sei: this.patient.sei ?? '',
                sei_kana: this.patient.sei_kana ?? '',
                tel: this.patient.tel ?? '',
                // Optionalは空ならnull送信
                prefecture: (this.pref_selected && this.pref_selected.trim()) ? this.pref_selected : null,
                doctor: (this.doctor_selected && this.doctor_selected.trim()) ? this.doctor_selected : null,
                staff: (this.staff_selected && this.staff_selected.trim()) ? this.staff_selected : null,
                last_come: null,
            };
            console.log(data);


            // validation
            let valid = this.$refs.form.validate()
            if(!valid){
                console.log('%c'+valid, mycolor.strong);
                return false;
            }

            if(this.edit_mode){
                // 更新の場合は患者idが必要
                data['id'] = this.$route.params.id;

                axios.post('/patient_update', data, { headers: { 'Content-Type': 'application/json' } })
                  .then((res) => {
                    console.log(res.data);
                    if( res.data.status==='OK'){
                       this.snackbar_text = `${this.patient.sei} ${this.patient.mei} 様の情報を更新しました`;
                       this.snackbar = true;
                       console.log('更新しました');
                    }
                  })
                  .catch( (error) => {
                      console.group('%c/patient_update ERROR', mycolor.red);
                      if (error && error.response) {
                          console.log('status:', error.response.status);
                          console.log('data  :', error.response.data);
                      } else {
                          console.error(error);
                      }
                      console.groupEnd();
                  });
            }else{

                axios.post('/patient_touroku', data, { headers: { 'Content-Type': 'application/json' } })
                  .then((res) => {
                    console.log(res.data);
                    if( res.data.status==='OK'){
                       this.$router.push('/patientlist').catch(()=>{});
                    }
                  })
                  .catch( (error) => {
                      console.group('%c/patient_touroku ERROR', mycolor.red);
                      if (error && error.response) {
                          console.log('status:', error.response.status);
                          console.log('data  :', error.response.data);
                          try {
                              this.$toast && this.$toast.error('登録エラー: ' + (error.response.data.detail ? JSON.stringify(error.response.data.detail) : JSON.stringify(error.response.data)));
                          } catch (e) {}
                      } else {
                          console.error(error);
                      }
                      console.groupEnd();
                  });
            }

        },  // submit()

        async fetchAddress() {
            console.log('fetchAddress');

            // 郵便番号のバリデーションチェック
            const reg = /^\d{7}$/
            if (!reg.test(this.zipcode)){
                console.log(this.zipcode);
                return false;
            }


            let params = {
                    zipcode: this.zipcode
                };

            const ZIPCODE_API_URL = 'https://api.zipaddress.net/?zipcode='+ this.zipcode;
            axios.get(ZIPCODE_API_URL, params)
              .then((res) => {
                  console.log(res.data.data);
                  let ret = res.data;

                  // 存在しない郵便番号でapiを叩くと200以外のステータスが返ってくる
                  if (ret.code !== 200) return;


                  // 上書いてしまうとまずいので、空でないことを確認する
                  this.patient.pref_selected = ret.data.pref;
                  this.patient.city = ret.data.city;
                  if( !this.patient.address ){
                      this.patient.address = ret.data.town;
                  }

              })
              .catch((error) => {
                  console.error(error);
              });
        },

        validphone(name, v){
            // 電話番号の整形
            console.log('validphone');
            console.log(name);
            if( name==='tel' ){
                this.patient.tel = v.replace(/-/mg, '');
            }else if( name==='phone' ){
                this.patient.phone = v.replace(/-/mg, '');
            }
        }, // validphone

      // 初期化 todo:
      initialize () {

        console.log('initialize');
        console.log(this.$route);

        // 担当医のリスト取得
        axios.get('/staff_names/doctor')
          .then((res) => {
            console.group();
            console.log('%c担当医のリスト取得', mycolor.api);
            console.log(res);
            console.groupEnd();
            this.doctor = res.data
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
          });

        // スタッフのリスト取得
        axios.get('/staff_names/all')
          .then((res) => {
            console.group();
            console.log('%cスタッフリスト取得', mycolor.api);
            console.log(res);
            console.groupEnd();
            this.staff = res.data
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
          });


        if( this.$route.name!=='patient_update' ){
            console.log('患者情報登録');
            this.title = '患者情報登録';
            this.edit_mode = false;
        }else{
            console.log('患者情報編集');
            this.title = '患者情報編集';
            this.edit_mode = true;
            console.log(this.$route.params.id);


            axios.get('/patient/'+this.$route.params.id)
              .then((res) => {
                console.group();
                console.log('%cpatient/'+this.$route.params.id, mycolor.api);
                let ret = res.data[0];
                console.log(ret);
                console.groupEnd();
                this.patient = ret;
                this.doctor_selected = ret.doctor;
                this.staff_selected = ret.staff;
                this.pref_selected = ret.prefecture;

              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });
        }

      },  // initialize

    },  // methods


    created () {
      console.log('%ccreated: PatientView.vue', mycolor.purple);
      this.initialize()
    },

    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },  // computed



    watch: {

        'patient.post1'(val, oldval){
            console.log(val, oldval);
            this.zipcode = this.patient.post1+this.patient.post2;
            console.log('post1 updated: '+this.zipcode);
        },
        'patient.post2'(val, oldval){
            console.log(val, oldval);
            this.zipcode = this.patient.post1+this.patient.post2;
            console.log('post2 updated: '+this.zipcode);
        },
        /*
            patient: {
                handler(val){
                    // do stuff
                    console.log('watch');
                    console.log(val);
                },
                deep: true
            }
        */
    },  // watch

  }


</script>


<style scoped>
/*
カレンダーの土日に色をつける
*/

.v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(1) .v-btn__content {
    color:red
}
.v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(7) .v-btn__content {
    color:blue
}

.mycard{
  height: 1640px;
}
.myform .row{
  max-height: 100px;
}
.v-input__slot{
   background: #f0f0f0 !important;
}
/*
.container{
  border: 1px solid green;
}
.row{
  border: 1px solid red;
}
.col{
  border: 1px solid blue;
}
*/
/deep/ .gray .v-input__slot{
    background:#F0F0F0 !important;
}
/deep/ .gray_radio{
    background:#F0F0F0 !important;
}
/deep/ .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: 48px;
}
/deep/ .v-text-field.v-textarea:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: unset !important;
}
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ .row + .row{
    margin-top: 0px;
}
/deep/ .mywhite .v-input__slot{
    background: #fff;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .myselect .v-input__control .v-input__slot{
    width: 226px !important;
    max-width: 226px !important;
}
/deep/ .myselect .v-input__control .v-text-field__details{
    width: 226px !important;
    max-width: 226px !important;
}
/deep/ .myselect{
    width: 226px !important;
    max-width: 226px !important;
    margin-right:10px;
    margin-top: 2px;
}
/deep/ .myselect .v-input__slot{
    height: 42px !important;
}
/deep/ .mypost{
    display: inline-block;
    width: 120px;
    vertical-align: middle;
}
/deep/ .mypost .v-text-field__details{
    display: none;
}
/deep/ .v-snack--vertical .v-snack__wrapper{
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    margin-top: 84px;
    min-width: unset;
    padding: 0 20px;
}
/deep/ .v-snack__content{
    padding: 0px !important;
    margin-right: 30px;
}
/deep/ .v-snack--vertical .v-snack__wrapper .v-snack__action{
    margin: 0 !important;
    align-self: unset !important;
}
/deep/ .v-snack:not(.v-snack--has-background) .v-snack__wrapper{
    border: none !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
